import Reflux from 'reflux';
import http from '../../helper/ajax';

const GridActions = Reflux.createActions(['getBuilderData', 'publishHelper']);

// builder-ajax
GridActions.getBuilderData.preEmit = (reqData) => {
  http.post('load_request_data', reqData).end((error, res) => {
    if (res) {
      GridActions.publishHelper(JSON.parse(res.text));
    }
  });
};

export default GridActions;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/action/gridActions.js